import { data } from './constant';
import PolicyType from '@components/PolicyType';

enum TYPE {
  text = 'Terms & Conditions',
}

const TermsAndConditions = () => {
  return <PolicyType data={data} type={TYPE.text} />;
};

export default TermsAndConditions;
